import { useAuth } from "@/hooks/useAuth";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export default function PlatformAdminRoute() {
  const { isAuthenticated, authHydrated, user } = useAuth();

  if (!authHydrated) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== "PLATFORM_ADMIN") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
